import React, { useState } from 'react';
import { stylistAPI } from '../../../../services/api';
import { X } from 'lucide-react';

const SubscriptionModal = ({ clientId, currentSubscription, onClose, onUpdated }) => {
  const [count, setCount] = useState(5);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(currentSubscription ? 'add' : 'create');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === 'create') {
        await stylistAPI.createSubscription(clientId, {
          client_id: clientId,
          subscription_type: count === 5 ? '5 действий' : count === 10 ? '10 действий' : 'индивидуальный',
          total_actions: count,
          used_actions: 0
        });
      } else {
        await stylistAPI.addActionsToSubscription(clientId, count, note);
      }
      onUpdated();
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getActionWord = (n) => {
    if (n === 1) return 'действие';
    if (n >= 2 && n <= 4) return 'действия';
    return 'действий';
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-l)', zIndex: 1000 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'var(--white)', padding: 'var(--space-xxl)', maxWidth: '400px', width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-xl)' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem' }}>
            {mode === 'create' ? 'Оформить подписку' : 'Пополнить подписку'}
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} /></button>
        </div>

        <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'var(--mid-gray)', marginBottom: 'var(--space-l)' }}>
          1 действие = создание образа или рекомендации к покупке
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Количество действий
            </label>
            <div style={{ display: 'flex', gap: 'var(--space-s)' }}>
              {[5, 10, 15].map((num) => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setCount(num)}
                  style={{
                    flex: 1,
                    padding: '12px',
                    backgroundColor: count === num ? 'var(--black)' : 'var(--cream)',
                    color: count === num ? 'var(--white)' : 'var(--charcoal)',
                    border: 'none',
                    fontFamily: 'var(--font-body)',
                    fontSize: '0.9375rem',
                    cursor: 'pointer'
                  }}
                >
                  {num}
                </button>
              ))}
            </div>
          </div>

          {mode === 'add' && (
            <div style={{ marginBottom: 'var(--space-l)' }}>
              <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
                Комментарий (опционально)
              </label>
              <input
                type="text"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Оплата, бонус..."
                style={{ width: '100%', padding: '12px', fontFamily: 'var(--font-body)', fontSize: '0.9375rem', border: '1px solid var(--soft-gray)', boxSizing: 'border-box' }}
              />
            </div>
          )}

          <button type="submit" disabled={loading} style={{ width: '100%', padding: '16px', backgroundColor: 'var(--black)', color: 'var(--white)', border: 'none', fontFamily: 'var(--font-body)', fontSize: '0.8125rem', letterSpacing: '1px', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Сохранение...' : mode === 'create' ? `Создать на ${count} ${getActionWord(count)}` : `Добавить ${count} ${getActionWord(count)}`}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubscriptionModal;
